import { render, staticRenderFns } from "./CusDrugList.vue?vue&type=template&id=367fdb1a&scoped=true&"
import script from "./CusDrugList.vue?vue&type=script&lang=js&"
export * from "./CusDrugList.vue?vue&type=script&lang=js&"
import style0 from "./CusDrugList.vue?vue&type=style&index=0&id=367fdb1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367fdb1a",
  null
  
)

export default component.exports